/** 方案中心：行业案例 + 机器人开发方案 */

export const solutionTabs = [
  { id: 'cases', label: '行业案例' },
  { id: 'dev', label: '机器人开发方案' },
]

const img = (file) => `/images/brochure/${file}`
const sys = (file) => `/images/systems/${file}`

/** cardStyle: photo 全幅实景 | product 深色底产品展示 */
export const industryCaseRows = [
  {
    columns: 2,
    items: [
      {
        id: 'smart-manufacturing',
        title: '智能制造',
        image: img('img-p7-5.jpeg'),
        position: 'center 45%',
        categoryId: 'automation-line',
        cardStyle: 'photo',
      },
      {
        id: 'vocational-education',
        title: '职业教育',
        image: '/images/competition-training.png',
        position: 'center 40%',
        categoryId: 'smart-line',
        cardStyle: 'photo',
      },
      {
        id: 'logistics',
        title: '仓储物流',
        image: img('img-p5-9.png'),
        position: 'center 55%',
        categoryId: 'agv',
        cardStyle: 'photo',
      },
      {
        id: 'power-energy',
        title: '电力能源',
        image: sys('pv-dashboard.png'),
        position: 'center top',
        categoryId: 'energy-system',
        cardStyle: 'photo',
      },
    ],
  },
  {
    columns: 3,
    items: [
      {
        id: 'electronics-3c',
        title: '3C电子',
        image: img('img-p12-3.jpeg'),
        categoryId: 'automation-line',
        cardStyle: 'photo',
        position: 'center 40%',
      },
      {
        id: 'automotive',
        title: '汽车',
        image: img('img-p17-4.jpeg'),
        categoryId: 'automation-line',
        cardStyle: 'photo',
        position: 'center center',
      },
      {
        id: 'semiconductor',
        title: '半导体',
        image: img('img-p7-3.jpeg'),
        categoryId: 'automation-line',
        cardStyle: 'photo',
        position: 'center 35%',
      },
      {
        id: 'telecom',
        title: '电子通信',
        image: img('img-p17-2.jpeg'),
        categoryId: 'network-platform',
        cardStyle: 'photo',
        position: 'center 30%',
      },
      {
        id: 'manufacturing',
        title: '制造业',
        image: img('img-p11-5.jpeg'),
        position: 'center 45%',
        categoryId: 'estun-trainer',
        cardStyle: 'photo',
      },
      {
        id: 'competition',
        title: '竞赛培训',
        image: img('img-p11-3.jpeg'),
        position: 'center 50%',
        categoryId: 'smart-line',
        cardStyle: 'photo',
      },
    ],
  },
]

export const robotDevSolutions = [
  {
    id: 'mobile-chassis',
    title: '移动底盘',
    image: '/images/amr-chassis.png',
    categoryId: 'mobile-platform',
    accent: 'linear-gradient(165deg, #1a3055 0%, #0a1220 50%, #050810 100%)',
    glow: 'rgba(77, 163, 255, 0.22)',
  },
  {
    id: 'controller-kit',
    title: '控制器及配件',
    image: img('img-p16-2.jpeg'),
    categoryId: 'plc-trainer',
    accent: 'linear-gradient(165deg, #1e2844 0%, #0c1020 50%, #060810 100%)',
    glow: 'rgba(100, 140, 255, 0.18)',
  },
  {
    id: 'robot-software',
    title: '机器人应用软件',
    image: sys('power-curve.png'),
    categoryId: 'software',
    accent: 'linear-gradient(165deg, #152238 0%, #0a1525 50%, #050a12 100%)',
    glow: 'rgba(26, 140, 255, 0.2)',
  },
  {
    id: 'agv-forklift',
    title: 'AGV定制开发',
    image: img('img-p5-6.jpeg'),
    categoryId: 'agv',
    accent: 'linear-gradient(165deg, #1a2844 0%, #0d1525 55%, #060a12 100%)',
    glow: 'rgba(77, 163, 255, 0.2)',
  },
  {
    id: 'composite-robot',
    title: '复合移动机器人',
    image: img('img-p5-9.png'),
    categoryId: 'mobile-platform',
    accent: 'linear-gradient(165deg, #1c2e4a 0%, #0e1828 50%, #070b14 100%)',
    glow: 'rgba(90, 170, 255, 0.2)',
  },
  {
    id: 'humanoid',
    title: '人形机器人',
    image: img('img-p4-18.jpeg'),
    categoryId: 'humanoid',
    accent: 'linear-gradient(165deg, #222840 0%, #101828 50%, #080c14 100%)',
    glow: 'rgba(120, 160, 255, 0.18)',
  },
]

export const solutionPageHero = {
  tone: 'system',
  icon: 'automation',
  eyebrow: 'Solutions',
  title: '方案中心',
  desc:
    '天津高仁科技以客户需求为导向，提供智能制造、职业教育、仓储物流等多行业机器人应用方案，以及移动底盘、控制器、应用软件等机器人开发整体解决方案。',
  image: '/images/competition-training.png',
  photoFrame: 'light',
}

export const solutionHeroImage = '/images/cemat-hero-ref.png'

export const solutionNavLabels = {
  行业案例: 'cases',
  机器人开发方案: 'dev',
}

export const defaultSolutionTab = 'cases'
